import { dashboardSession } from '@unipile/db';
import { createInsertSchema, createSelectSchema } from 'drizzle-typebox';

export const DashboardSessionSchema = createSelectSchema(dashboardSession);

export const InsertDashboardSessionSchema = createInsertSchema(dashboardSession);

export type DashboardSession = typeof dashboardSession.$inferSelect;
export type InsertDashboardSession = typeof dashboardSession.$inferInsert;

/** Session metadata for internal services; authentication material is excluded. */
export type DashboardSessionDetails = Omit<DashboardSession, 'token_hash'> & {
  effective_expires_at: string;
};
